export default __webpack_public_path__ + "static/media/pec-logo.7494ca80.svg";